module.exports = __webpack_public_path__ + "img/FGr_Räumen_A.cc3dc161.svg";